module.exports = __webpack_public_path__ + "img/curv_15_a.38901fd2.jpg";